import styled from "@emotion/styled";
import { List } from "@material-ui/core";
import { units } from "../../../types/units";

export const ListContainer = styled.div`
  margin: 0 0 2rem;
`;

export const ListStyledOrder = styled(List)`
  padding: 0;

  .MuiListItem-root {
    ${units({
      backgroundColor: "white",
    })};
  }

  &.edit-mode {
    .MuiListItem-root {
      &:hover {
        background-color: #e0f5ff !important;
      },
    }
  }

  .MuiListItemIcon-root {
    min-width: 0;
    position: absolute;
    top: 2rem;
    left: 0;
  }

  .MuiListItem-container {
    border-bottom: 1px solid;
    ${units({
      borderColor: "lightGrey",
    })};
  }

  @media (max-width: 960px) {
    .MuiListItem-root {
      align-items: start;
    }
    .MuiListItemIcon-root {
      margin: 1.25rem 1.5rem 0 -1rem;
      top: 0.75rem;
      left: 1rem;
    }
    .MuiListItemSecondaryAction-root {
      top: 3rem;
    }
  }
`;
